import { combineReducers } from "redux";
import navbar from "./navbar";
import projects from "./projects";
import projectDetail from "./project_detail";
import issues from "./issues";
import issueDetail from "./issue_detail";
import current from "./current";
import siteConfigs from "./site_configs";
import editConfig from "./edit_config";
import search from "./search";
import users from "./users";

export default combineReducers({
  navbar,
  projects,
  projectDetail,
  issues,
  issueDetail,
  siteConfigs,
  editConfig,
  current,
  search,
  users,
});
